import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { callApi } from "./API/Api";

// const supportedLangs = ["en", "ru", "ar", "pt", "es", "fr", "ko"];
const supportedLangs = [
  {
    Name: "English",
    Code: "en",
  },
  {
    Name: "Português",
    Code: "pt",
  },
  {
    Name: "Русский",
    Code: "ru",
  },
  {
    Name: "Española",
    Code: "es",
  },
  {
    Name: "عربي",
    Code: "ar",
  },
  {
    Name: "Français",
    Code: "fr",
  },
  {
    Name: "한국인",
    Code: "ko",
  },
];
function useLanguage() {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const [langcode, setLangcode] = useState({
    Code: "en",
    Name: "English",
  });
   
  
  const [isRtl, setIsRtl] = useState(false);
  useEffect(() => {
    if (!lang) return;
    const checkLang = supportedLangs.find(
      (item) => item.Code === lang
    );

    if (!checkLang) {
  const path = window.location.pathname;
  const search = window.location.search;

  const browserLang = navigator.language.slice(0, 2);
  const lang = supportedLangs.some(l => l.Code === browserLang)
    ? browserLang
    : "en";

  navigate(`/${lang}${path}${search}`, { replace: true });
  return;
}

     const langObj = {
      Code: checkLang.Code,
      Name: checkLang.Name,
    };
    setLangcode(langObj);
    i18n.changeLanguage(lang);
    localStorage.setItem("langcode", JSON.stringify(langObj));
    if (lang === "ar") {
       const restrictedPaths = [
      "userdashboard",
      "userdashboarddeposit",
      "accounthistory",
      "analytics",
      "marketdashboard",
      "supportdashboard",
      "setting",
    ];
    const location = window.location;
  const pathSegments = location.pathname.split("/");
    if(restrictedPaths.includes(pathSegments[2])){
        document.body.style.direction = "ltr";
      document.body.style.textAlign = "left";
      setIsRtl(false);
      return;
    }
      document.body.style.direction = "rtl";
      document.body.style.textAlign = "right";
      setIsRtl(true);
    } else {
      document.body.style.direction = "ltr";
      document.body.style.textAlign = "left";
      setIsRtl(false);
    }
  }, [lang, i18n, navigate]);

  return { langcode, isRtl };
}

export default useLanguage;
